import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { ERROR_MESSAGE_LIST, notificationError } from '../components/Notifications/callNotifcation';

export const SERVER_ENVIRONMENT_RELEASE = 'release';
export const SERVER_ENVIRONMENT_TEST = 'testing';
export const SERVER_ENVIRONMENT_DEV = 'dev';

const BASE_API_URLS: Record<string, string> = {
	[SERVER_ENVIRONMENT_RELEASE]: 'https://app.wakadoo.pro/api/',
	[SERVER_ENVIRONMENT_TEST]: 'https://test.app.wakadoo.pro/api/',
	[SERVER_ENVIRONMENT_DEV]: 'http://localhost:25504/api/',
};

const apiBaseUrl = BASE_API_URLS[process.env.REACT_APP_ENVIRONMENT_SERVER || SERVER_ENVIRONMENT_DEV];

export const apiSlice = createApi({
	reducerPath: 'api',
	baseQuery: fetchBaseQuery({
		baseUrl: apiBaseUrl,
		credentials: 'include',
	}),
	endpoints: () => ({}),
});

export const handleApiError = (error: any) => {
	if (error.status) {
		switch (error.status) {
		case 400:
			if (process.env.NODE_ENV === 'development') console.error(error);
			notificationError(ERROR_MESSAGE_LIST.ERROR, 'Введенные данные некорректны!');
			break;
		default:
			console.error(error);
		}
	} else {
		notificationError(
			'Ошибка получения данных!',
			'Мы уже устраняем неисправность, попробуйте обновить страницу через некоторое время!',
		);
	}
};

export default apiSlice;
